import React from "react";
import { destroyAvatar, uploadAvatar } from "src/actions/mine_craft/avatarsActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewGroupParams } from "src/store/mine_craft/avatarsSlice";

import DrawerRight from "src/componets/DrawerRight";
import GroupUpload from "src/componets/FileDropzone/GroupUpload";
import mineCraftApi from "src/api/mineCraftApi";
import { message } from "antd";

const Dropzone = () => {
  const dispatch = useAppDispatch();
  const newGroupParams = useAppSelector(state => state.mineCraft.avatars.newGroupParams);
  const data: any = { app_id: newGroupParams?.app_id };

  function onClose() {
    dispatch(setNewGroupParams(null));
  }

  function handleUploadSuccess(response: any) {
    dispatch(uploadAvatar(response));
  }

  function onClickDestroy(file: any) {
    const id = file.response?.avatar?.id;
    if (id) {
      handleDestroy(id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAvatar(id));

    if (destroyAvatar.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyAvatar.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <DrawerRight
      open={!!newGroupParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-newGroup-avatar'>
        <h6 className="v-content-label">Avatars Dropzone</h6>

        <GroupUpload
          name='image'
          action={mineCraftApi.oneSky.url('/onesky/avatars')}
          headers={mineCraftApi.oneSky.uploadHeaders}
          data={data}
          onSuccess={handleUploadSuccess}
          listType='picture'
          onRemove={onClickDestroy}
        />
      </div>
    </DrawerRight>
  )
}

export default Dropzone;
